<template>
    <spinner-until :condition="!!practice">
        <div class="practice-handouts mb-3 mt-page">

            <h1>
                {{ $i18n.gt('HEADING_PRACTICE_DOCUMENTS_FOR') }} {{ practice.name }}
            </h1>

            <div :class="$mq == 'sm' ? '' : 'mx-5'">
                <attachment-manager model-class="Practice"
                                    model-table="practice"
                                    :model-id="practiceId"
                                    accept="application/pdf"
                                    extensions="pdf">
                </attachment-manager>
            </div>
        </div>
    </spinner-until>
</template>

<script>

import Vue from 'vue'

/**
 * Page for Practitioner to manage documents (attachments) for their Practice -
 * these can be arranged in custom categories (groups) for the practice.
 */
export default Vue.extend({
    name: 'PracticeDocuments',
    props: {
        practiceId: Number
    },
    data() {
        return {
            practice: null,
        }
    },
    async mounted() {
        const practice = await this.$api.getItem(this, 'practice', this.practiceId)
        this.practice = practice
    },
})
</script>
